document.addEventListener("DOMContentLoaded", () => {
  const buyButton = document.querySelector(".main-button");
  const stickyAtc = document.querySelector(".sticky-atc");
  const stickyHeader = document.querySelector(".ed-header"); // Replace with your header selector
  const selectedOption = stickyAtc.querySelector(".selected-option");
  const optionsContainer = stickyAtc.querySelector(".options");

  if (buyButton && stickyAtc && stickyHeader) {
    function updateStickyAtc() {
      const headerHeight = stickyHeader?.offsetHeight || 0;
      const rect = buyButton.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Show sticky ATC if buy button is not visible in viewport
      // Button is not visible if: above header or below viewport
      const isAboveViewport = rect.bottom <= headerHeight;
      const isBelowViewport = rect.top >= viewportHeight;
      const isNotVisible = isAboveViewport || isBelowViewport;

      if (isNotVisible) {
        stickyAtc.classList.add("is-sticky");
      } else {
        stickyAtc.classList.remove("is-sticky");
        optionsContainer.classList.remove("open");
      }
    }

    selectedOption.addEventListener("click", (event) => {
      if (optionsContainer) {
        optionsContainer.classList.toggle("open");
      }
    });

    document.addEventListener("click", (event) => {
      if (
        optionsContainer &&
        !optionsContainer.contains(event.target) &&
        !selectedOption.contains(event.target)
      ) {
        optionsContainer.classList.remove("open");
      }
    });

    // Update on scroll and resize
    window.addEventListener("scroll", updateStickyAtc, { passive: true });
    window.addEventListener("resize", updateStickyAtc);

    // Initial check - run immediately and after a short delay to ensure DOM is ready
    updateStickyAtc();
    setTimeout(updateStickyAtc, 100);
  }
});
